/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import pendo, { LEARNER_API_KEY } from 'js/lib/pendo';
import user from 'js/lib/user';

import { Button } from '@coursera/cds-core';

import _t from 'i18n!nls/xdp';

const usePendo = () =>
  React.useEffect(() => {
    pendo.init(
      {
        visitor: {
          id: user.get()?.external_id,
          isCourserian: user.isCourserian(),
        },
      },
      LEARNER_API_KEY
    );
  }, []);

type Props = {
  productSlug: string;
  productType: 'course' | 'project' | 'specialization' | 'professional-certificate';
  programSlug?: string;
};

export const AssignButtonNotConfigurable = (props: Props): React.ReactElement => {
  const { productType, productSlug, programSlug } = props;
  const search = React.useMemo(() => {
    const searchParams = new URLSearchParams();
    searchParams.append('page', `assign/${productType}/${productSlug}`);
    searchParams.append('ref', 'xdp');
    if (programSlug) {
      searchParams.append('program', programSlug);
    }
    return searchParams.toString();
  }, [productSlug, productType, programSlug]);
  usePendo();
  return (
    <Button component="a" href={`/o/my?${search}`} variant="ghost" id="assign">
      {
        {
          course: _t('Assign this course'),
          project: _t('Assign this project'),
          specialization: _t('Assign this specialization'),
          'professional-certificate': _t('Assign this certificate'),
        }[productType]
      }
    </Button>
  );
};

export default AssignButtonNotConfigurable;
